class InspectorGroupNames {
  public static readonly Completeness = "Completeness";
  public static readonly Eligibility = "Eligibility";
  public static readonly Enrichment = "Enrichment";
  public static readonly Integrity = "Integrity";
  public static readonly Standardization = "Standardization";
  public static readonly Validity = "Validity";
}

export {
  InspectorGroupNames
}